import { Typography, Box, Grid } from '@mui/material';
import React, { useContext, useEffect, useState } from 'react';
import Content from '../components/Layout/Content';
import SearchBar from '../components/SearchBar/Search';
import { BreadcrumbComponent } from '../components/BreadcrumbComponent/BreadcrumbComponent';
import ApplicationContext from '../context/applicationContext';
import FormularyItem from '../components/FormularyComponent/FormularyCard';
import {
  formularyArrayConvertor,
  getIconFromSubItemsArray,
} from '../shared/helper';
import { useQuery } from '@apollo/client';
import { FETCH_ALL_FORMULARY_QUERY } from '../services/FormularyQueries/FormularyQueries';
import { useSnackbar } from 'notistack';
import { SimpleBackdrop } from '../components/SimpleBackdropComponent/SimpleBackdrop';
import {
  FORMULARY,
  FORMULARY_BREADCRUMBDATA as breadcrumbData,
} from '../shared/Strings';
import NotFound from '../components/NotFound/NotFoundPage';

export const Formulary = () => {
  const [formularyData, setFormularyData] = useState([]);
  const { menuItems } = useContext(ApplicationContext);
  const { enqueueSnackbar } = useSnackbar();
  const [formularies, setFormularies] = useState(formularyData);
  const [search, setSearch] = useState();
  useEffect(() => setFormularies(formularyData), [formularyData]);

  const allFormulary = useQuery(FETCH_ALL_FORMULARY_QUERY, {
    variables: { sourceUrl: '' },
    onError: err => {
      enqueueSnackbar(FORMULARY.ON_ERROR_TEXT.WENT_WRONG_TEXT, {
        variant: 'error',
      });
    },
  });

  const {loading,error} = allFormulary;

  useEffect(() => {
    if (allFormulary?.data?.fetchAllFormulary) {
      setFormularyData(
        formularyArrayConvertor(allFormulary.data.fetchAllFormulary)
      );
    }
  }, [allFormulary.data]);

  const bySearch = (formulary, search) => {
    if (search) {
      return formulary.title.toLowerCase().includes(search.toLowerCase());
    } else return formulary;
  };

  const filteredList = (formularies, search) => {
    return formularies.filter(formulary => bySearch(formulary, search));
  };
  let resultValues = filteredList(formularies,search);

  return (
    <Content>
      <BreadcrumbComponent
        breadcrumbData={breadcrumbData}></BreadcrumbComponent>
      <Typography variant="title">{FORMULARY.TITLE_TEXT}</Typography>
      <Box sx={{ mt: 3 }}>
        <SearchBar
          sx={{ width: '50%', minWidth: '300px', maxWidth: '500px' }}
          onSearch={setSearch}
          placeholder={FORMULARY.SEARCH_PLACEHOLDER_TEXT}
        />
      </Box>
      <Grid container spacing={2} mt={3}>
        {(error || (!loading && (!resultValues.length || resultValues.length === 0) )) ? <NotFound title={FORMULARY.TITLE_TEXT} sx={{ mt: 2 }}/>   : resultValues?.map((item, index) => (
          <Grid item key={index}>
            <FormularyItem
              data={item}
              icon={
                menuItems
                  ? getIconFromSubItemsArray(
                      menuItems?.Medical?.subItems,
                      'Formulary'
                    )
                  : null
              }
            />
          </Grid>
        ))}
      </Grid>
      <SimpleBackdrop open={loading} />
    </Content>
  );
};
